import { useContext } from "react";
import { CartContext } from "src/lib/components/salify-next-layout/default/contexts/CartContext";

const useCart = () => useContext(CartContext);

export default useCart;
